import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faInstagram,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

const API_BASE = import.meta.env.VITE_API_BASE_URL ?? "http://localhost:5000";

interface AdminPage {
  page_name: string | null;
  slug: string | null;
  record_status_id: number;
}

export default function Footer() {
  const [aboutSlug,   setAboutSlug]   = useState("/about-us");
  const [contactSlug, setContactSlug] = useState("/contact-us");

  useEffect(() => {
    fetch(`${API_BASE}/api/v1/website/pages`)
      .then((r) => r.json())
      .then((data) => {
        for (const p of (data.pages ?? []) as AdminPage[]) {
          if (p.record_status_id !== 1 || !p.slug) continue;
          const name = p.page_name?.toLowerCase().trim() ?? "";
          if (name === "about us")   setAboutSlug(p.slug);
          if (name === "contact us") setContactSlug(p.slug);
        }
      })
      .catch(() => {});
  }, []);

  return (
    <section className="relative">
      <img
        src="/images/bg-top.png"
        alt=""
        aria-hidden="true"
        width={1161}
        height={71}
        loading="lazy"
        decoding="async"
        className="w-full h-auto"
      />

      <footer className="hidden md:block  mt-mobile-fix relative bg-green-700 pb-10">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 md:gap-10">
          <div>

            <h3 className="font-bold mb-3">Contact Us</h3>

            <p className="mb-3">
              <FontAwesomeIcon
                icon={faLocationDot}
                className="text-black text-lg px-2"
              />
              <strong>Phonics Power Educational Services</strong> <br />
              <span className="block mt-1 pl-40">
                120, Silapathigaram Street, Ganesh Nagar, Selaiyur, Chennai -
                600 073
              </span>
            </p>

            <p className="mb-2">
              <FontAwesomeIcon
                icon={faPhone}
                className="text-black text-lg px-2"
              />
              +91 98840 88958 | 98841 88158
            </p>
            <p>
              {" "}
              <FontAwesomeIcon
                icon={faEnvelope}
                className="text-black text-lg px-2"
              />{" "}
              info@phonicspower.com
            </p>
          </div>

          <div className="px-100">
            <h3 className="font-bold mb-4">Quick Links</h3>

            <ul className="space-y-2">
              <li><Link to="/" className="hover:text-white">Home</Link></li>
              <li><Link to={aboutSlug} className="hover:text-white">About Us</Link></li>
              <li><Link to="/Phonics" className="hover:text-white">Phonics</Link></li>
              <li><Link to="/SpokenEnglish" className="hover:text-white">Spoken English</Link></li>
              <li><Link to="/GrammarWriting" className="hover:text-white">Grammar &amp; Writing</Link></li>
            </ul>
            <div className="flex gap-4 mt-6">
              <div className="footer-icon bg-[#1E293980] text-white rounded-lg hover:scale-110">
                <a href="https://www.facebook.com/share/1HqEbm2jSf/" className="" aria-label="Phonics Power on Facebook" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faFacebookF} />
                </a>
              </div>
              <div className="footer-icon bg-[#1E293980] text-white rounded-lg hover:scale-110">
                <a href="https://www.instagram.com/phonicspower/" className="" aria-label="Phonics Power on Instagram" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
              </div>
              <div className="footer-icon bg-[#1E293980] text-white rounded-lg hover:scale-110">
                <a href="https://youtube.com/@phonicspower?si=WrNT-JfESxVLlAz8" className="" aria-label="Phonics Power on YouTube" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faYoutube} />
                </a>
              </div>
            </div>
          </div>

          <div>
            <p className="font-semibold mb-4 invisible">Links</p>

            <ul className="space-y-2">
               <li><Link to="/CambridgeEnglish" className="hover:text-white">Cambridge English</Link></li>
              <li><Link to="/training-school" className="hover:text-white">Training for Schools</Link></li>
              <li><Link to="/centres" className="hover:text-white">Centres</Link></li>
              <li><Link to={contactSlug} className="hover:text-white">Contact Us</Link></li>
            </ul>

            
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-6 mt-10 pt-6 border-t border-black flex flex-col md:flex-row justify-between text-sm">
          <p>© 2026  Phonics Power Educational Services LLP . All rights reserved.</p>

          <div className="flex gap-6 mt-3 md:mt-0">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-and-conditions">Terms of Service</Link>
          </div>
        </div>
      </footer>
      {/* -----------This is Mobile Version of Footer---------------- */}
         <footer className="md:hidden block  mt-mobile-fix relative bg-green-700 pt-4 pb-10 text-gray-900">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 md:gap-10">
          <div>
<div className="pb-10">
            <h3 className="font-bold mb-4">Quick Links</h3>

            <ul className="space-y-2">
              <li><Link to="/" className="hover:text-white">Home</Link></li>
              <li><Link to={aboutSlug} className="hover:text-white">About Us</Link></li>
              <li><Link to="/Phonics" className="hover:text-white">Phonics</Link></li>
              <li><Link to="/SpokenEnglish" className="hover:text-white">Spoken English</Link></li>
              <li><Link to="/GrammarWriting" className="hover:text-white">Grammar &amp; Writing</Link></li>
              <li><Link to="/CambridgeEnglish" className="hover:text-white">Cambridge English</Link></li>
              <li><Link to="/training-school" className="hover:text-white">Training for Schools</Link></li>
              <li><Link to="/centres" className="hover:text-white">Centres</Link></li>
              <li><Link to={contactSlug} className="hover:text-white">Contact Us</Link></li>

            </ul>
            
          </div>

            <h3 className="font-bold mb-3">Contact Us</h3>

            <p className="mb-3">
              <FontAwesomeIcon
                icon={faLocationDot}
                className="text-black text-lg px-2"
              />
              <strong>Phonics Power Educational Services</strong> <br />
              <span className="block mt-1 pl-40">
                120, Silapathigaram Street, Ganesh Nagar, Selaiyur, Chennai -
                600 073
              </span>
            </p>

            <p className="mb-2">
              <FontAwesomeIcon
                icon={faPhone}
                className="text-black text-lg px-2"
              />
              +91 98840 88958 | 98841 88158
            </p>
            <p>
              {" "}
              <FontAwesomeIcon
                icon={faEnvelope}
                className="text-black text-lg px-2"
              />{" "}
              info@phonicspower.com
            </p>
          </div>

          <div className="flex gap-4 mt-6">
              <div className="footer-icon bg-[#1E293980] text-white rounded-lg">
                <a href="https://www.facebook.com/share/1HqEbm2jSf/" className="" aria-label="Phonics Power on Facebook" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faFacebookF} />
                </a>
              </div>
              <div className="footer-icon bg-[#1E293980] text-white rounded-lg">
                <a href="https://www.instagram.com/phonicspower/" className="" aria-label="Phonics Power on Instagram" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
              </div>
              <div className="footer-icon bg-[#1E293980] text-white rounded-lg">
                <a href="https://youtube.com/@phonicspower?si=WrNT-JfESxVLlAz8" className="" aria-label="Phonics Power on YouTube" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faYoutube} />
                </a>
              </div>
            </div>

        
        </div>

        <div className="max-w-7xl mx-auto px-6 mt-10 pt-6 border-t border-black flex flex-col md:flex-row justify-between text-sm">
          <p>© 2026 Phonics Power Institute. All rights reserved.</p>

          <div className="flex gap-6 mt-3 md:mt-0">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-and-conditions">Terms of Service</Link>
          </div>
        </div>
      </footer>
    </section>
    
    
  );
}
